import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { normalizedResponseToBodyOnly } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { AmountRateResponseDTO, ExchangeCalculateRequestDTO, IExchangeCalculateRepository } from '../entities';

class ExchangeCalculateRepositoryImpl implements IExchangeCalculateRepository {
  constructor() {
    this.PostExchangeCalculate = this.PostExchangeCalculate.bind(this);
  }

  PostExchangeCalculate(data: ExchangeCalculateRequestDTO): Promise<AmountRateResponseDTO> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/transfers/exchange/calculate',
        data,
        dataAdapter: normalizedResponseToBodyOnly,
      },
    });
  }
}

export { ExchangeCalculateRepositoryImpl };
